export default "__VITE_ASSET__NdSfKwqV__"